import ProfileInformation from '../../pages/settings/ProfileInformation'
import ChangePassword from '../../pages/settings/ChangePassword'
import UserManagementTable from '../../pages/settings/UserManagementTable'

import React, { useState } from "react";

const SettingSideBar = () => {
  const [activeTab, setActiveTab] = useState("profile");

  return (
    <div className="flex flex-col lg:flex-row mt-10">
      <nav>
        <div className="py-2 text-sm lg:text-md lg:text-lg font-semibold text-center rounded-tr-md rounded-tl-md bg-[#E7E7E7] w-full">
          Settings Menu
        </div>
        <div className="bg-white flex flex-row lg:flex-col h-fit lg:min-w-[200px] xl:min-w-[250px] max-w-full border-r border-l border-b border-[#E7E7E7] rounded-br-md rounded-bl-md gap-5">
          <div className="flex flex-row lg:flex-col w-full">
            <button
              className={`text-sm lg:text-md text-center text-[#0A0A0A]/80 mt-4 px-4 py-2 w-full text-left ${
                activeTab === "profile" ? "bg-orange text-black font-medium" : "hover:bg-gray-100"
              }`}
              onClick={() => setActiveTab("profile")}
            >
              Profile Info
            </button>
            <button
              className={`text-sm lg:text-md text-center text-[#0A0A0A]/80 font-medium px-4 py-2 w-full text-left ${
                activeTab === "password" ? "bg-orange text-black font-medium" : "hover:bg-gray-100"
              }`}
              onClick={() => setActiveTab("password")}
            >
              Change Password
            </button>
            <button
              className={`text-sm lg:text-md text-center text-[#0A0A0A]/80 font-medium px-4 py-2 w-full text-left ${
                activeTab === "management" ? "bg-orange text-black font-medium" : "hover:bg-gray-100"
              }`}
              onClick={() => setActiveTab("management")}
            >
              User Management
            </button>
          </div>
        </div>
      </nav>
      <div className="flex-1 pt-6 lg:pt-0 lg:p-6 border-[#E7E7E7] bg-white">
        {activeTab === "profile" && (
          <div>
            <ProfileInformation />
          </div>
        )}
        {activeTab === "password" && (
          <div>
            <ChangePassword />
          </div>
        )}
        {activeTab === "management" && (
          <div>
           <UserManagementTable />
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingSideBar;
